import { useEffect, useRef, useState } from "react";
import { useOverLimitTrigger } from "@/pages/dashboard/components/OverLimitTip";
import { getLocale, shallowEqual, useSelector } from "umi";
import moment from "moment";
import { downLoadPcConsoleV3DayPerformanceTable, getPcConsoleV3DayPerformanceTable } from "@/pages/dashboard/services/overview";
import { LANGUAGE_MAP, PERIODTIMEOBJ } from "@/pages/dashboard/_config/constant";
import { IsSingleDay } from "@/pages/dashboard/utils/utils";
import { PagingQuery } from "tea-component";
import { getTableRequestParams } from "./hooks";
import { ComponentMetricsItemType } from "@/pages/dashboard/components/PageContainer/type";
import { SortBy } from "tea-component/lib/table/addons";

const useData = (
  filterValue: any,
  filterLoading: boolean,
  selectType: string,
  config: {
    api: any,
    componentMetrics: ComponentMetricsItemType
  },
  // getRequestParams: Function,
) => {
  const { api: apiObj, componentMetrics } = config || {}
  // 加载状态
  const [loading, setLoading] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);
  // // 分页
  const [paging, setPaging] = useState<PagingQuery>({ pageSize: 10, pageIndex: 1 });
  // // 排序
  const [sort, setSort] = useState<SortBy[]>([])
  // 总条数
  const [total, setTotal] = useState(0)
  const [frontLogicalFlag, setFrontLogicalFlag] = useState<string | undefined>(undefined)
  const { overLimitBarTriggerKey, handleResponse } = useOverLimitTrigger()

  // 表格数据
  const [tableData, setTableData] = useState([])

  // 聚合数据
  const [statisticsData, setStatisticsData] = useState([])

  // const [,forceUpdate] = useReducer(x=>x+1,0)
  const filterValueSort = useRef(filterValue);
  const accumulateOldValueRef = useRef(['date'])

  const gameCode = useSelector((state: any) => state?.dashboard?.currentGame?.game_code, shallowEqual)
  // 获取表格上传参数
  const getRequestParams = (paging: any, sort: any, filterValue: any, otherParams?: any) => {

    // overview页面的日期上传参数逻辑与其他页面不同, 故特殊处理
    let { timeType, metrics, event } = filterValue || {};
    let periodObj = { period: PERIODTIMEOBJ?.[timeType] || 'daily' }
    const isAll = event?.event?.length === 1 && event?.event?.[0] === '255'
    // 和后端核对后如果选中了所有，则传给后端空数组
    // 是否取消勾选date维度
    const hasDate = accumulateOldValueRef?.current?.includes('date')
    // 是否单日单周单月
    const isSingle = IsSingleDay({ rangeTime: filterValue?.rangeTime, period: PERIODTIMEOBJ[filterValue?.timeType] })
    // 是否累计值计算逻辑
    const isAccumulated = !hasDate && !isSingle;

    return getTableRequestParams({
      gameCode, filterValue,
      accumulated: accumulateOldValueRef?.current,
      sort: sort,
      paging: paging,
      selectType,
      metrics: isAccumulated && metrics?.includes('active_users') ? metrics?.map((w: any) => {
        if (w === 'active_users') return 'avg_dau'
        return w
      }) || metrics || [] : metrics || [],
      event_type_list: !isAll ? event?.eventType : [],
      event_name_list: !isAll ? event?.event : [],
      ...otherParams,
      ...periodObj
    })
  }

  useEffect(() => {
    filterValueSort.current = { filterValue, paging }
  }, [filterValue, paging, sort])

  // 点击筛选器的时候
  useEffect(() => {
    if (filterLoading) return;
    setPaging({ pageIndex: 1, pageSize: paging.pageSize });
    setSort([])
    const params = getRequestParams({ pageIndex: 1, pageSize: paging.pageSize }, [], filterValue)
    getTableData(params);

  }, [filterValue, filterLoading])


  const getTableData = (params: any) => {
    setIsError(false);
    setLoading(true);
    const api = `${apiObj?.tableApi}?language=${LANGUAGE_MAP[getLocale()]}`

    getPcConsoleV3DayPerformanceTable(api, {...params,filter_event_date_field: 'start_time'}).then((resp) => {
      setLoading(false);
      setTableData(resp.metrics_list || [])
      setStatisticsData(resp.aggregation || [])
      // 设置总条数
      setTotal(resp.row_count)
      setFrontLogicalFlag(resp?.front_logical_flag)
      handleResponse(resp?.front_logical_flag)
    }).catch(e => {
      setLoading(false)
      setIsError(true);
      console.log("overview 宽表请求错误: ", filterValue.timeType, e);
    })
  }


  return {
    tableData,
    statisticsData,
    paging,
    loading,
    isError,
    sort,
    total,
    frontLogicalFlag,
    overLimitBarTriggerKey,
    filterValueSort,
    accumulateOldValueRef,
    isSingle: IsSingleDay({ ...filterValue, period: PERIODTIMEOBJ[filterValue?.timeType] }),
    setPaging,
    setSort,
    getRequestParams,
    getData: getTableData,
    downLoadData: downLoadPcConsoleV3DayPerformanceTable
  }
}

export default useData;